import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { menuActions } from "../../../_store/menu.slice";
import { useDispatch, useSelector } from "react-redux";

const InnerPage = () => {
  const { url } = useParams();

  const dispatch = useDispatch();
  const MenuResData = useSelector((x) => x?.menu?.getMenuResponseData?.data);

  useEffect(() => {
    dispatch(menuActions.getMenuData("/" + url));
  }, [url]);

  useEffect(() => {
    if (!MenuResData) return;
    const links = document.querySelectorAll(".paragraph a");
    links.forEach((a) => {
      const href = a.getAttribute("href");
      if (!href || href === "#" || href.startsWith("javascript:")) {
        if (!a.getAttribute("role")) {
          a.setAttribute("role", "button");
        }
      }
      if (
        a.textContent.trim().toUpperCase() === "CLICK HERE" &&
        !a.getAttribute("aria-label")
      ) {
        a.setAttribute("aria-label", "Learn more");
      }
    });
  }, [MenuResData]);

  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  return (
    <div>
      <section
        className="hero-section IP-Background-Image"
        style={{
          backgroundImage: `url(${ImageURL}${MenuResData?.bannerImage})`,
        }}
      >
        <span className="sr-only" role="img" aria-label={MenuResData?.title}></span>
        <div className="overlay"></div>
        <div className="hero-content">
          {/* <h1 className="fw-bold display-5 mb-50">Collective Impact</h1> */}
          <h1 className="fw-bold display-5 mb-50">{MenuResData?.title}</h1>
        </div>
      </section>
      <section className="paragraph">
        <div className="container">
          <div className="row">
            <div
              className="col-md-12"
              dangerouslySetInnerHTML={{
                __html: MenuResData?.descriptionOne,
              }}
            ></div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div
              className="col-md-12"
              dangerouslySetInnerHTML={{
                __html: MenuResData?.descriptionTwo,
              }}
            ></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InnerPage;
